import { render, staticRenderFns } from "./InputDocument.vue?vue&type=template&id=91e240c2&scoped=true"
import script from "./InputDocument.vue?vue&type=script&lang=js"
export * from "./InputDocument.vue?vue&type=script&lang=js"
import style0 from "./InputDocument.vue?vue&type=style&index=0&id=91e240c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e240c2",
  null
  
)

export default component.exports